import React from 'react'
import { Link } from 'react-router-dom'
import abimg2 from '../../images/about/4.jpg'
import shape1 from '../../images/ab-shape-1.png'
import shape2 from '../../images/ab-shape-2.png'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const About = (props) => {
    return (
        <section className={`wpo-about-section section-padding ${props.abClass || ''}`}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-12"> {/* Mobilde tam genişlik */}
                        <div className="wpo-about-wrap">
                            <div className="wpo-about-img">
                                <img src={props.abimg} alt="KYS Lojistik Ana Görsel" />
                                <div className="wpo-ab-shape-1">
                                    <img src={shape1} alt="Shape" />
                                </div>
                                <div className="wpo-ab-shape-2">
                                    <img src={shape2} alt="Shape" />
                                </div>
                                <div className="wpo-about-exprience">
                                    <h3>10+ Yıllık Tecrübe</h3>
                                </div>
                                <div className="wpo-ab-img-2">
                                    <img src={abimg2} alt="Proje Görseli" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-text">
                            <h4>
                                KYS Lojistik Proje İnşaat Madencilik Makina San. ve Tic. Ltd. Şti.
                            </h4>

                            <h2>
                                Sektörde güven veren mühendislik ve uygulama çözümleri,
                                <b> <span>10+ yıllık</span> deneyim.</b>
                            </h2>

                            <p>
                                2016 yılından bu yana; soğutma sistemleri, iç mimarlık & proje uygulama
                                ve iş makineleri alanlarında çok disiplinli mühendislik hizmetleri
                                sunuyoruz. Kalite standartlarını esas alan, güven odaklı ve sürdürülebilir
                                hizmet anlayışımızla projelerimizi teknik yeterlilik, zamanında teslim
                                ve maksimum müşteri memnuniyeti ilkesiyle hayata geçiriyoruz.
                            </p>

                            <p>
                                Enerji verimliliği yüksek, ekonomik ve uzun ömürlü çözümler üretirken;
                                güçlü teknik altyapımız ve deneyimli kadromuzla anahtar teslim projeler
                                sunuyor, müşterilerimizle uzun vadeli ve güvene dayalı iş ortaklıkları
                                kurmayı hedefliyoruz.
                            </p>

                            <Link
                                onClick={ClickHandler}
                                className="theme-btn"
                                to="/about"
                            >
                                Hakkımızda
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default About;